import create from "zustand";

// 전역 모달 관리
export const useModalStore = create((set) => ({
    is_open: false,
    data: null,
    direct_is_open: false,
    direct_data: null,
    setModal: (modal_data) =>
        set((state) => ({
            is_open: true,
            data: modal_data ? { ...modal_data } : {},
        })),
    closeModal: () =>
        set((state) => ({
            is_open: false,
            data: null,
        })),
    //샷시와 직접공정추가모달은 추후, 하나로 통합할 예정
    //샷시추가모달
    setSashModal: (modal_data) =>
        set((state) => ({
            sash_modal_is_open: true,
            sash_data: { ...modal_data } || {},
        })),
    closeSashModal: () =>
        set((state) => ({
            sash_modal_is_open: false,
            sash_data: null,
        })),
    //직접공정추가모달
    setDirectModal: (modal_data) =>
        set((state) => ({
            direct_is_open: true,
            direct_data: modal_data ? { ...modal_data } : {},
        })),
    closeDirectModal: () =>
        set((state) => ({
            direct_is_open: false,
            direct_data: null,
        })),
}));
